// src/App.js
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { WebRouter } from "./Routes/WebRouter";
import { AuthProvider } from "./contexts";


function App() {
  return (
    <AuthProvider>
        <BrowserRouter>
          <WebRouter />
        </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
